export default "__VITE_ASSET__CgaFHIq8__"